import React, { FC } from 'react'
import polaroidStyles from '../Polaroid.module.scss'
import classNames from 'classnames'
import Skeleton from 'components/SA/Skeleton'

type PolaroidSkeletonProps = {
  customClassName?: string
  width?: number
  height?: number
}

export const PolaroidCompleteSkeleton = () => {
  return (
    <div className={classNames(polaroidStyles.polaroidSkeletonContainer)}>
      <Skeleton width='100%' height='320px' />
      <Skeleton width='100%' height='26px' />
      <Skeleton width='100%' height='22px' />
      <Skeleton width='100%' height='18px' />
      <Skeleton width='100%' height='18px' />
    </div>
  )
}

export const PolaroidSkeleton: FC<PolaroidSkeletonProps> = ({
  customClassName = '',
  width,
  height,
}) => {
  return (
    <div
      className={classNames(polaroidStyles.polaroidSkeletonContainer, {
        [customClassName]: customClassName !== '',
      })}
    >
      <Skeleton width={`${width}px`} height={`${height}px`} />
      {/* <Skeleton width='100%' height={imageHeight} /> */}
    </div>
  )
}
